import { FreeNoticeDownloadTabs } from './pages';
import { useFreeNoticeDownloadMain } from './hooks/useFreeNoticeDownloadMain';

export function FreeNoticeDownloadServicePage() {
	useFreeNoticeDownloadMain();

	return <FreeNoticeDownloadTabs />;
}
